import { Button } from "antd";
import { ReactComponent as Plus } from "assets/icons/plus-primary-square.svg";
import { ReactComponent as Share } from "assets/icons/share-box.svg";
import { useTranslation } from "react-i18next";

const AddToHomeContent = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="border-b border-gray--7 pb-6 flex flex-col items-center text-center pt-1">
        <img
          src={"https://cdn.firouzeh.com/public/firouze-addtohome-logo.svg"}
          alt="logo"
        />
        <span className="mt-3  text-gray-4 body-14px-demibold ">
          {t("add-to-home")}
        </span>
      </div>
      <ol className="mt-6 mb-10 text-gray-0 body-14px-regular list-inside list-decimal space-y-3">
        <li> فیروزه را در مرورگر سافاری خود باز کنید. </li>
        <li>
          در نوار پایین روی دکمه{" "}
          <span className="text-primary-1 body-14px-demibold inline-flex items-center">
            Share
            <Share className="mx-1" />
          </span>
          بزنید.
        </li>
        <li>
          در منوی باز شده در قسمت پایین گزینه{" "}
          <span className="text-primary-1 body-14px-demibold inline-flex items-center">
            {" "}
            Add To Home Screen
            <Plus className="mx-1" />
          </span>
          را انتخاب کنید.
        </li>
        <li>
          در مرحله بعد در قسمت بالا روی{" "}
          <span className="text-primary-1 body-14px-demibold">Add</span> بزنید.
        </li>
      </ol>

      <Button
        className="primary-button-large justify-center mb-1"
        block
        onClick={() => onClick()}
      >
        {t("accept-add-to-home")}
      </Button>
    </>
  );
};

export default AddToHomeContent;
